/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ brand: NonNullable<unknown>, since: NonNullable<unknown> }} Inbound_Waiting_On_BrandInputs */

const en_inbound_waiting_on_brand = /** @type {(inputs: Inbound_Waiting_On_BrandInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on ${i?.brand} · authorization · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on {brand} · authorization · since {since}" |
*
* @param {Inbound_Waiting_On_BrandInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_waiting_on_brand = /** @type {((inputs: Inbound_Waiting_On_BrandInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Waiting_On_BrandInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_waiting_on_brand(inputs)
});